module.exports = __webpack_public_path__ + "static/bmw4-8b7ea2eb7ee833ec05d7e71d87ed440f.jpg";